module.exports = __webpack_public_path__ + "img/xjb3.4401fb64.jpg";